import { render, staticRenderFns } from "./baseData.vue?vue&type=template&id=e09118ac&scoped=true&"
import script from "./baseData.vue?vue&type=script&lang=js&"
export * from "./baseData.vue?vue&type=script&lang=js&"
import style0 from "./baseData.vue?vue&type=style&index=0&id=e09118ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09118ac",
  null
  
)

export default component.exports